/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable import/order */
import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/style';
import { useTranslation } from 'react-i18next';
import { useGetOrganizationTypeListQuery } from '@bvi/admin-panel/entities/organization-type/api-slice';
import { selectOrganizationType } from '@bvi/admin-panel/entities/organization-type/selectors';
import { Span } from '@bvi/common-components';
import { IOrganizationTypeData } from '@bvi/api-interfaces/response/manage-base-data';
import { OrganizationTypeTableRow } from './organization-type-row';

interface IOrganizationTypesTableProperties {
  query: string;
}

const OrganizationTypesTableComponent: FC<IOrganizationTypesTableProperties> = ({
  query,
}) => {
  const { t } = useTranslation();

  const { data: organizationTypeList, isLoading: isOrganizationTypeLoading } = useGetOrganizationTypeListQuery(
    undefined,
    {
      selectFromResult: ({ data, isLoading }) => ({
        data: selectOrganizationType(data),
        isLoading,
      }),
    },
  );

  const filteredAndSorted = useMemo(() => {
    const list = query
      ? organizationTypeList.filter((s: IOrganizationTypeData) => {
          const lower = query.toLowerCase();
          return (
            String(s.id).includes(lower) ||
            (s.name?.toLowerCase().includes(lower) ?? false)
          );
        })
      : [...organizationTypeList];

    return list.sort((a: IOrganizationTypeData, b: IOrganizationTypeData) => {
      const nameA = a.name?.toLowerCase() ?? '';
      const nameB = b.name?.toLowerCase() ?? '';
      return nameA.localeCompare(nameB);
    });
  }, [query, organizationTypeList]);

  const tableColumns = [
    {
      title: t('manageBaseTable.table.columns.id'),
      width: '10%',
    },
    {
      title: t('manageBaseTable.table.columns.name'),
      width: '60%',
    },
    {
      title: t('manageBaseTable.table.columns.createdAt'),
      width: '20%',
    },
    {
      width: '70px',
    },
  ];

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={styles.fixedTable}>
          <TableHead>
            <TableRow>
              {tableColumns.map((column, index) => (
                <TableCell width={column.width} key={index}>
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isOrganizationTypeLoading ? (
              <TableRow>
                <TableCell colSpan={tableColumns.length} align="center">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <CircularProgress size={24} />
                  </Stack>
                </TableCell>
              </TableRow>
            ) : (
              filteredAndSorted.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={tableColumns.length} align="center">
                    <Span>{t('manageBaseTable.table.results.empty')}</Span>
                  </TableCell>
                </TableRow>
              ) : (
                filteredAndSorted.map(
                  (organizationType: IOrganizationTypeData) => (
                    <OrganizationTypeTableRow
                      organizationType={organizationType}
                      key={organizationType.id}
                    />
                  ),
                )
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const OrganizationTypesTable = memo(OrganizationTypesTableComponent);

